import { Autocomplete, Box, Button, Divider, FormControl, Grid, TextField, Typography } from "@mui/material";
import { GetAllUsers } from "../../../../hooks/getUsers";
import { useEffect, useState } from "react";
import { use } from "react";
import { GetRoles } from "../../../../hooks/getRoles";
import { EditarReporte } from "../../../../hooks/reporteQuery";
import { useLoading } from "../../../../components/Loading/useLoading";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


export const UserActions = ({id_reporte, users_share = [], set_user_share, roles_share = [], set_roles_share}) => {

	const username = useSelector((state) => state.auth.user.username);
	const {setAppLoading} = useLoading()
	const navigate = useNavigate();
	const { enqueueSnackbar } = useSnackbar();
	const {getRolesMutation} = GetRoles();
	const {getAllUsersMutation} = GetAllUsers();
	const { editarReporteMutation } = EditarReporte();
	const [roles, setRoles] = useState([]);
	const [users, setUsers] = useState([]);
	const [userTransfer, setUserTransfer] = useState(null);


	const get_all_users = () => {
		setAppLoading(true);
		getAllUsersMutation({},{
			onSuccess: (data) => {
				const filteredUsers = data.filter(user => users_share.some(sharedUser => (sharedUser.username || sharedUser) === user.username));
				set_user_share(filteredUsers);
				setUsers(data);
				setAppLoading(false);
			},
			onError: (error) => {
				console.log(error);
				setAppLoading(false);
			}
		})
	}
	const get_roles = () => {
		setAppLoading(true);
		getRolesMutation({},{
			onSuccess: (data) => {
				const filteredRoles = data.filter(role => roles_share.some(sharedRole => (sharedRole.roleName || sharedRole) === role.roleName));
				set_roles_share(filteredRoles);
				setRoles(data);
				setAppLoading(false);
			},
			onError: (error) => {
				console.log(error);
				setAppLoading(false);
			}
		})
	}
	useEffect(() => {
		get_all_users();
		get_roles();
	}, []);

	const save_repo_share = () => {
		let roles_data = null;
		let users_data = null;
		if(roles_share.length > 0){
			roles_data = roles_share.map(role => role.roleName).join(', ');
		}
		if(users_share.length > 0){
			users_data = users_share.map(user => user.username).join(', ');
		}
		let body = {
			repo_userscompartidos: users_data,
			repo_rolescompartidos: roles_data,
		}
		setAppLoading(true);
		editarReporteMutation({id: id_reporte, body},{
			onSuccess: (data) => {
				setAppLoading(false);
				enqueueSnackbar('Reporte compartido correctamente', {
					variant: 'success',
					autoHideDuration: 2000,
					anchorOrigin: {
						vertical: 'top',
						horizontal: 'center',
					},
				});
			},
			onError: (error) => {
				setAppLoading(false);
				enqueueSnackbar('Error al compartir el reporte', {
					variant: 'error',
					autoHideDuration: 2000,
					anchorOrigin: {
						vertical: 'top',
						horizontal: 'center',
					},
				});
				console.log(error)
			}
		})

	}
	const save_repo_transfer = () => {
		let body = {
			usu_id: userTransfer?.username || username,
		}
		setAppLoading(true);
		editarReporteMutation({id: id_reporte, body},{
			onSuccess: (data) => {
				setAppLoading(false);
				enqueueSnackbar('Reporte transferido correctamente', {
					variant: 'success',
					autoHideDuration: 2000,
					anchorOrigin: {
						vertical: 'top',
						horizontal: 'center',
					},
				});
				navigate(`/reportes/personalizado`);
			},
			onError: (error) => {
				setAppLoading(false);
				enqueueSnackbar('Error al transferir el reporte', {
					variant: 'error',
					autoHideDuration: 2000,
					anchorOrigin: {
						vertical: 'top',
						horizontal: 'center',
					},
				});
				console.log(error)
			}
		})
	}

	return (
		<Grid container spacing={0} sx={{mt:1}}>
			<Grid item xs={12}>
				<Typography variant="h6" sx={{mb:1, color: "#575E3B"}}>
					Compartir Reporte
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<FormControl size="small" fullWidth>
					<Autocomplete
					fullWidth
					multiple
					id={`user_autocomplete`}
					getOptionLabel={(opcion) => `${opcion.givenName} ${opcion.familyName} - (${opcion.username})` }
					filterSelectedOptions
					options={users}
					onKeyDown={(e) => {
						if(e.key === 'Enter' || e.key === 'Tab'){
							e.preventDefault();
						}
					}}
					value={users_share}
					onChange={(e, newValue)=>set_user_share(newValue)}
					renderOption={(props, opcion)=> (
							<Box {...props} key={`${opcion.givenName} ${opcion.familyName} - (${opcion.username})`}>{`${opcion.givenName} ${opcion.familyName} - (${opcion.username})`}</Box>
					)}
					renderInput={(params) => 
							<TextField {...params} label="Usuario" size="small" fullWidth  required/>
					}
					/>
				</FormControl>
			</Grid>	
			<Grid item xs={12} sx={{mt:2}}>
				<FormControl size="small" fullWidth>
					<Autocomplete
					fullWidth
					multiple
					id={`roles_autocomplete`}
					getOptionLabel={(opcion) => `${opcion.roleName}` }
					filterSelectedOptions
					options={roles}
					onKeyDown={(e) => {
						if(e.key === 'Enter' || e.key === 'Tab'){
							e.preventDefault();
						}
					}}
					value={roles_share}
					onChange={(e, newValue)=>set_roles_share(newValue)}
					renderOption={(props, opcion)=> (
							<Box {...props} key={`${opcion.roleName}`}>{`${opcion.roleName}`}</Box>
					)}
					renderInput={(params) => 
							<TextField {...params} label="Roles" size="small" fullWidth  required/>
					}
					/>
				</FormControl>
			</Grid>	
			<Grid item xs={12} sx={{mt:2}}>
				<Button 
					variant="contained" 
					className="btn_system"
					onClick={save_repo_share}
					>
						Compartir
				</Button>
			</Grid>	
			<Divider sx={{width: '100%', borderColor:'#575E3B66', mt:6, mb:4}}/>
			<Grid item xs={12}>
				<Typography variant="h6" sx={{mb:1, color: "#575E3B"}}>
					Transferir Reporte
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<FormControl size="small" fullWidth>
					<Autocomplete
					fullWidth
					id={`user_autocomplete`}
					getOptionLabel={(opcion) => `${opcion.givenName} ${opcion.familyName} - (${opcion.username})` }
					filterSelectedOptions
					options={users}
					onKeyDown={(e) => {
						if(e.key === 'Enter' || e.key === 'Tab'){
							e.preventDefault();
						}
					}}
					onChange={(e, newValue)=>setUserTransfer(newValue)}
					renderOption={(props, opcion)=> (
							<Box {...props} key={`${opcion.givenName} ${opcion.familyName} - (${opcion.username})`}>{`${opcion.givenName} ${opcion.familyName} - (${opcion.username})`}</Box>
					)}
					renderInput={(params) => 
							<TextField {...params} label="Usuario" size="small" fullWidth  required/>
					}
					/>
				</FormControl>
			</Grid>		
			<Grid item xs={12} sx={{mt:2}}>
				<Button 
					variant="contained" 
					className="btn_system"
					onClick={save_repo_transfer}
					>
						Transferir
				</Button>
			</Grid>	
		</Grid>
	);
};
